<template>
  <div class="layouts-list">
    <top-bar
      title="Layouts"
      :show-add-button="true"
      add-button-label="Añadir Layout"
      @addItem="$router.push({name: 'layouts-create'})"
    />
    <scrollable-container>
      <div class="padding-20">
        <ms-grid
          :data="items"
          :columns="columns"
          :options="options"
          :pager="pager"
        >
          <div
            slot="dealerTypes"
            slot-scope="{row}"
          >
            <span
              class="dealer-type"
              v-for="dealer of row.dealerTypes"
              :key="dealer"
            >
              {{ dealer }}
            </span>
          </div>
        </ms-grid>
      </div>
    </scrollable-container>
    <router-view/>
  </div>
</template>

<script>
import TopBar from '@/components/top-bar'
import ScrollableContainer from '@/components/scrollable-container'
import MsGrid from '@/modules/grid/ms-grid'
import StarRating from '@/components/star-rating.vue'
import { mapGetters } from 'vuex'
import DefaultGuards from '@/guards/default.guards'
import DefaultActions from '@/helpers/default-actions'

export default {
  name: 'LayoutList',
  components: {
    TopBar,
    ScrollableContainer,
    StarRating,
    MsGrid
  },
  data () {
    return {
      dialogCloneVisible: false,
      columns: [
        {
          label: 'ID',
          property: 'id',
          align: 'center'
        },
        {
          label: 'Nombre',
          property: 'name',
          link (row) {
            return { name: 'layouts-edit', params: { id: row.id } }
          }
        },
        {
          label: 'División',
          property: 'division',
          align: 'center'
        },
        {
          label: 'Tipos de Sucursal',
          property: 'dealerTypes',
          align: 'center'
        },
        {
          label: 'Estatus',
          property: 'status',
          align: 'center',
          filter: value => {
            let status = { published: 'Publicado', unpublished: 'Borrador' }
            return status[value] || '-'
          }
        },
        {
          label: 'Creado',
          property: 'createdAt',
          type: 'date'
        }
      ],
      options: {
        selectable: false,
        actions: [
          DefaultActions.edit('layouts'),
          {
            label: 'Diseñar',
            icon: 'icon-box',
            onClick: row => {
              this.$router.push({ name: 'designer', params: { id: row.id } })
            }
          },
          {
            label: 'Clonar',
            icon: 'icon-view_module',
            onClick: row => {
              this.$router.push({
                name: 'layouts-clone',
                params: { id: row.id }
              })
            }
          },
          DefaultActions.delete('layouts')
        ]
      }
    }
  },
  computed: {
    ...mapGetters('layouts', {
      items: 'items',
      pager: 'pagination'
    })
  },
  methods: {
    randomStar () {
      return Math.ceil(Math.random() * 5)
    }
  },
  beforeRouteUpdate: DefaultGuards.onQuery('layouts', {}, ['name']),
  beforeRouteEnter: DefaultGuards.onQuery('layouts', {}, ['name'])
}
</script>

<style lang="scss" scoped>
.layouts-list {
  max-height: 100%;
  overflow: hidden;
  .dealer-type {
    border: 1px solid $color-ui-primary;
    margin: 0 3px;
    width: 12px;
    text-align: center;
    display: inline-block;
    color: $color-ui-primary;
    padding: 1px 3px;
    border-radius: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/layouts/layouts-list-view.vue